import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function getCarrierDisplayName(carrier: string | null | undefined): string {
  if (carrier === "GO" || carrier === "go") return "GO! Express";
  return carrier || "Onbekend";
}

